module.exports = __webpack_public_path__ + "img/GoCardCredit@2x.fcc251e1.png";